import { render, staticRenderFns } from "./HeadComponent.vue?vue&type=template&id=c54bb712&scoped=true&"
import script from "./HeadComponent.vue?vue&type=script&lang=js&"
export * from "./HeadComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeadComponent.vue?vue&type=style&index=0&id=c54bb712&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54bb712",
  null
  
)

export default component.exports